import { creatorbase, creatorbaseQueries } from '@round/api';
import { useQueryClient } from '@tanstack/react-query';
import { useUpdateCampaign, useInvalidateAggregatedPostStats } from '@round/creatorbase-helpers/api-hooks';
import useInvalidateProjectCampaignContext from './useInvalidateProjectCampaignContext';

const COST_RELATED_FIELDS: (keyof creatorbase.PatchCampaignBody)[] = [
    'cost',
    'base_cost',
    'currency_id',
    'is_post_cost_editable',
];

// useUpdateCampaign invalidates every campaign query (keys.all) on success, which is broader
// than this project. Acceptable for now — observed queries off this project just get marked
// stale and only refetch when next visited.
export default function useUpdateProjectCampaign() {
    const queryClient = useQueryClient();
    const invalidateProjectCampaignContext = useInvalidateProjectCampaignContext();
    const invalidateAggregatedPostStats = useInvalidateAggregatedPostStats();

    return useUpdateCampaign(undefined, {
        onSuccess: (campaign, variables) => {
            invalidateProjectCampaignContext({
                project_id: campaign.project_id,
                platform: campaign.platform,
            });
            invalidateAggregatedPostStats({ campaign_id: campaign.id }).catch(() => {});

            if (COST_RELATED_FIELDS.some((field) => field in variables)) {
                queryClient.invalidateQueries({
                    queryKey: creatorbaseQueries.postPaymentDetails.keys.lists(),
                });
            }
        },
    });
}
